module.exports = __webpack_public_path__ + "static/media/close-icon-white.2ec3ffa2.svg";